module.exports = __webpack_public_path__ + "img/econsenso.8be3f1ee.png";